var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#F12F45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4991 11.6084C23.4824 11.6084 23.4574 11.6084 23.4324 11.6084C19.0241 11.1667 14.6241 11.0001 10.2657 11.4417L8.56574 11.6084C8.21574 11.6417 7.90741 11.3917 7.87408 11.0417C7.84074 10.6917 8.09074 10.3917 8.43241 10.3584L10.1324 10.1917C14.5657 9.74173 19.0574 9.91673 23.5574 10.3584C23.8991 10.3917 24.1491 10.7001 24.1157 11.0417C24.0907 11.3667 23.8157 11.6084 23.4991 11.6084Z",
    fill: "#F12F45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0826 10.7665C13.0493 10.7665 13.016 10.7665 12.9743 10.7582C12.641 10.6998 12.4076 10.3748 12.466 10.0415L12.6493 8.94984C12.7826 8.14984 12.966 7.0415 14.9076 7.0415H17.091C19.041 7.0415 19.2243 8.1915 19.3493 8.95817L19.5326 10.0415C19.591 10.3832 19.3576 10.7082 19.0243 10.7582C18.6826 10.8165 18.3576 10.5832 18.3076 10.2498L18.1243 9.1665C18.0076 8.4415 17.9826 8.29984 17.0993 8.29984H14.916C14.0326 8.29984 14.016 8.4165 13.891 9.15817L13.6993 10.2415C13.6493 10.5498 13.3826 10.7665 13.0826 10.7665Z",
    fill: "#F12F45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.674 24.9582H13.324C10.4157 24.9582 10.299 23.3498 10.2074 22.0498L9.66569 13.6582C9.64069 13.3165 9.90735 13.0165 10.249 12.9915C10.599 12.9748 10.8907 13.2332 10.9157 13.5748L11.4574 21.9665C11.549 23.2332 11.5824 23.7082 13.324 23.7082H18.674C20.424 23.7082 20.4574 23.2332 20.5407 21.9665L21.0824 13.5748C21.1074 13.2332 21.4074 12.9748 21.749 12.9915C22.0907 13.0165 22.3574 13.3082 22.3324 13.6582L21.7907 22.0498C21.699 23.3498 21.5824 24.9582 18.674 24.9582Z",
    fill: "#F12F45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3844 20.375H14.6094C14.2677 20.375 13.9844 20.0917 13.9844 19.75C13.9844 19.4083 14.2677 19.125 14.6094 19.125H17.3844C17.726 19.125 18.0094 19.4083 18.0094 19.75C18.0094 20.0917 17.726 20.375 17.3844 20.375Z",
    fill: "#F12F45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0846 17.0415H13.918C13.5763 17.0415 13.293 16.7582 13.293 16.4165C13.293 16.0748 13.5763 15.7915 13.918 15.7915H18.0846C18.4263 15.7915 18.7096 16.0748 18.7096 16.4165C18.7096 16.7582 18.4263 17.0415 18.0846 17.0415Z",
    fill: "#F12F45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.cc9ce50f741d6316ab5bf856479f17a1.svg";
export { ForwardRef as ReactComponent };